import React from "react";
import { Table } from "react-bootstrap";
import { Collapse } from "react-collapse";

const OrderDetailItems = ({ items, setOpen, open }) => {
  return items.map((x, i) => (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-bold">{x.service}</span>
            <span
              className="p-2 d-block"
              onClick={() => {
                setOpen((prev) => ({
                  ...prev,
                  [x.services_id]: !prev[x.services_id],
                }));
              }}
            >
              <i
                className={`fa-solid fa-angle-${
                  open[x.services_id] ? "down" : "right"
                }`}
              ></i>
            </span>
          </div>
          <Collapse isOpened={open[x.services_id]}>
            <div>
              <Table borderless responsive className="mb-0">
                <tbody>
                  {x.items.map((y) => (
                    <>
                      <tr>
                        <td
                          className={`py-1 ps-0 ${
                            y.addons?.length > 0 ? "pb-0" : ""
                          }`}
                        >
                          {y.quantity} x {y.name}
                        </td>
                        <td
                          className={`text-end py-1 pe-0 ${
                            y.addons?.length > 0 ? "pb-0" : ""
                          }`}
                        >
                          Rs.{" "}
                          {(
                            y.price *
                            (y.quantity - (y.free_items || 0))
                          ).toLocaleString()}
                        </td>
                      </tr>
                      {y.addons?.length > 0 ? (
                        <tr>
                          <td colSpan={2} className="px-2 py-0">
                            <Table borderless responsive>
                              <tbody>
                                {y.addons?.map((z) => (
                                  <tr>
                                    <td className="py-0">
                                      {z.qty} x {z.name}
                                    </td>
                                    <td className="py-0 text-end">
                                      Rs. {(z.price * z.qty).toLocaleString()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                      {y.item_note ?
                      <span
                        className=" py-0"
                        style={{fontSize:"12px", color: "#aaa" }}
                      > Note: {y.item_note}
                      </span> : null}
                      {y.is_bundle_active ? (
                        <tr>
                          <td colSpan={2}>
                            <div className="d-flex align-items-center">
                              <span
                                className="badge text-bg-dark d-flex align-items-center me-2"
                                style={{ width: "fit-content" }}
                              >
                                <img
                                  src={process.env.PUBLIC_URL + "/assets/images/bundle-stars.png"}
                                  alt=""
                                  height={18}
                                  style={{
                                    filter:
                                      "invert(83%) sepia(64%) saturate(2152%) hue-rotate(357deg) brightness(97%) contrast(105%)",
                                  }}
                                />
                              </span>
                              <span className="text-muted fst-italic">
                                (Bundle offer items included.)
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : null}
                    </>
                  ))}
                </tbody>
              </Table>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  ));
};

export default OrderDetailItems;
